const styles = (theme) => ({
  wrapper: {
    backgroundColor: theme.palette.common.white,
    padding: '40px 40px',
    '@media(max-width: 600px)': {
      padding: '20px 0px',
    },
  },
  innerContainer: {
    padding: '40px 40px',
    maxWidth: 1200,
    margin: 'auto',
    '@media(max-width: 600px)': {
      padding: '20px 16px',
    },
  },
  grayBg: {
    backgroundColor: theme.palette.common.blue50,
  },
});

export default styles;
